<div class="content-wrapper">
  <app-header></app-header>

  <div class="d-flex">
    <div class="sidebar">
      <app-sidebar></app-sidebar>
    </div>

    <div class="pc-container flex-grow-1 settings-page">

      <!-- ── Page Hero Header ── -->
      <div class="settings-hero fade-in">
        <div class="settings-hero-inner">
          <div class="settings-hero-icon">
            <i class="fas fa-cog"></i>
          </div>
          <div>
            <h1 class="settings-hero-title">{{ 'PROFILE.PAGE_TITLE_SETTINGS' | translate }}</h1>
            <p class="settings-hero-sub">Gérez votre profil, sécurité et préférences</p>
          </div>
        </div>
      </div>

      <!-- ── Main Layout ── -->
      <div class="settings-layout fade-in-up">

        <!-- ═══ LEFT SIDEBAR NAV ═══ -->
        <aside class="settings-aside" *ngIf="activeTab !== 'paiement'">
          <div class="aside-card">

            <!-- User mini-profile -->
            <div class="aside-profile">
              <div class="aside-avatar-wrap">
                <img [src]="getProfileImageSrc()"
                     alt="Avatar" class="aside-avatar"
                     (error)="$any($event.target).src='../../../../assets/img/Admin.png'" />
                <span class="aside-avatar-ring"></span>
              </div>
              <div class="aside-user-info">
                <p class="aside-name">{{ userProfile?.prenom }} {{ userProfile?.nom }}</p>
                <span class="aside-role-badge">{{ role }}</span>
              </div>
            </div>

            <div class="aside-divider"></div>

            <!-- Nav Items -->
            <nav class="aside-nav">
              <button class="aside-nav-item" [class.active]="activeTab === 'profile'"
                      (click)="activeTab = 'profile'" id="nav-profile">
                <span class="aside-nav-icon"><i class="fas fa-user-circle"></i></span>
                <span class="aside-nav-label">{{ 'PROFILE.NAV_PROFILE_SETTINGS' | translate }}</span>
                <i class="fas fa-chevron-right aside-nav-arrow"></i>
              </button>

              <button class="aside-nav-item" *ngIf="isParent()" [class.active]="activeTab === 'paiement'"
                      (click)="activeTab = 'paiement'" id="nav-paiement">
                <span class="aside-nav-icon"><i class="fas fa-credit-card"></i></span>
                <span class="aside-nav-label">Historique de Paiement</span>
                <i class="fas fa-chevron-right aside-nav-arrow"></i>
              </button>

              <button class="aside-nav-item" id="nav-password"
                      data-bs-toggle="modal" data-bs-target="#changePasswordModal">
                <span class="aside-nav-icon"><i class="fas fa-lock"></i></span>
                <span class="aside-nav-label">{{ 'PROFILE.NAV_PASSWORD' | translate }}</span>
                <i class="fas fa-chevron-right aside-nav-arrow"></i>
              </button>

              <button class="aside-nav-item" id="nav-notifications"
                      [class.active]="activeTab === 'notifications'"
                      (click)="activeTab = 'notifications'; loadNotificationsTab()">
                <span class="aside-nav-icon"><i class="fas fa-bell"></i></span>
                <span class="aside-nav-label">{{ 'PROFILE.NAV_NOTIFICATIONS' | translate }}</span>
                <span class="aside-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
              </button>

              <button class="aside-nav-item" id="nav-verification" (click)="openVerification()">
                <span class="aside-nav-icon"><i class="fas fa-shield-alt"></i></span>
                <span class="aside-nav-label">{{ 'PROFILE.NAV_VERIFICATION' | translate }}</span>
                <span class="aside-verified"><i class="fas fa-check-circle"></i></span>
              </button>
            </nav>
          </div>
        </aside>

        <!-- ═══ RIGHT CONTENT ═══ -->
        <main [class]="activeTab === 'paiement' ? 'settings-main full-width' : 'settings-main'">

          <!-- ────── TAB: PROFILE ────── -->
          <div *ngIf="activeTab === 'profile'" class="settings-card slide-in">

            <!-- Card Header -->
            <div class="card-section-header">
              <div class="card-header-left">
                <div class="card-header-icon gradient-purple">
                  <i class="fas fa-user-edit"></i>
                </div>
                <div>
                  <h2 class="card-section-title">{{ 'PROFILE.NAV_PROFILE_SETTINGS' | translate }}</h2>
                  <p class="card-section-sub">Mettez à jour vos informations personnelles</p>
                </div>
              </div>
            </div>

            <!-- Avatar Zone -->
            <div class="avatar-section">
              <div class="avatar-glow-wrap">
                <img [src]="getProfileImageSrc()"
                     alt="Avatar" class="main-avatar"
                     (error)="$any($event.target).src='../../../../assets/img/Admin.png'" />
                <button class="avatar-camera-btn" (click)="triggerFileInput()" type="button"
                        title="Changer la photo">
                  <i class="fas fa-camera"></i>
                </button>
                <input #fileInput type="file" accept="image/*" class="d-none"
                       (change)="onFileSelected($event)" />
              </div>
              <div class="avatar-actions">
                <p class="avatar-name">{{ userProfile?.prenom }} {{ userProfile?.nom }}</p>
                <p class="avatar-email-text">{{ userProfile?.userEmail }}</p>
                <div class="avatar-btns">
                  <button type="button" class="btn-upload" (click)="triggerFileInput()">
                    <i class="fas fa-upload me-2"></i>{{ 'PROFILE.UPLOAD_AVATAR' | translate }}
                  </button>
                  <button type="button" class="btn-remove" (click)="deleteAvatar()">
                    <i class="fas fa-trash-alt me-2"></i>{{ 'PROFILE.DELETE_AVATAR' | translate }}
                  </button>
                </div>
                <p class="avatar-hint">JPG, PNG ou GIF · Max 5 MB</p>
              </div>
            </div>

            <div class="section-divider"></div>

            <!-- Profile Form -->
            <form [formGroup]="editProfileForm" class="profile-form">

              <div class="form-grid">

                <!-- Prénom -->
                <div class="field-group">
                  <label class="field-label">
                    {{ 'PROFILE.FIELD_FIRSTNAME' | translate }}
                    <span class="required-star">*</span>
                  </label>
                  <div class="input-wrap" [class.input-error]="editProfileForm.get('prenom')?.invalid && editProfileForm.get('prenom')?.touched">
                    <span class="input-prefix-icon"><i class="fas fa-user"></i></span>
                    <input type="text" class="modern-input" formControlName="prenom"
                           placeholder="Ex: Makram" />
                  </div>
                  <span class="field-error" *ngIf="editProfileForm.get('prenom')?.invalid && editProfileForm.get('prenom')?.touched">
                    Prénom invalide (min. 2 caractères)
                  </span>
                </div>

                <!-- Nom -->
                <div class="field-group">
                  <label class="field-label">
                    {{ 'PROFILE.FIELD_LASTNAME' | translate }}
                    <span class="required-star">*</span>
                  </label>
                  <div class="input-wrap" [class.input-error]="editProfileForm.get('nom')?.invalid && editProfileForm.get('nom')?.touched">
                    <span class="input-prefix-icon"><i class="fas fa-user"></i></span>
                    <input type="text" class="modern-input" formControlName="nom"
                           placeholder="Ex: Ben Rhouma" />
                  </div>
                  <span class="field-error" *ngIf="editProfileForm.get('nom')?.invalid && editProfileForm.get('nom')?.touched">
                    Nom invalide (min. 2 caractères)
                  </span>
                </div>

                <!-- Email -->
                <div class="field-group full-span">
                  <label class="field-label">
                    {{ 'PROFILE.FIELD_EMAIL' | translate }}
                  </label>
                  <div class="input-wrap" [class.input-error]="editProfileForm.get('userEmail')?.invalid && editProfileForm.get('userEmail')?.touched">
                    <span class="input-prefix-icon"><i class="fas fa-envelope"></i></span>
                    <input type="email" class="modern-input" formControlName="userEmail"
                           placeholder="exemple@email.com" />
                  </div>
                  <span class="field-error" *ngIf="editProfileForm.get('userEmail')?.invalid && editProfileForm.get('userEmail')?.touched">
                    Format email invalide
                  </span>
                </div>

                <!-- Phone -->
                <div class="field-group">
                  <label class="field-label">
                    {{ 'PROFILE.FIELD_PHONE' | translate }}
                    <span class="required-star">*</span>
                  </label>
                  <div class="input-wrap phone-wrap" [class.input-error]="editProfileForm.get('userPhoneNumber')?.invalid && editProfileForm.get('userPhoneNumber')?.touched">
                    <div class="phone-prefix">
                      <img src="https://flagcdn.com/w20/tn.png" alt="TN" />
                      <span>+216</span>
                    </div>
                    <div class="phone-divider"></div>
                    <input type="text" class="modern-input" formControlName="userPhoneNumber"
                           placeholder="12 345 678" />
                  </div>
                  <span class="field-error" *ngIf="editProfileForm.get('userPhoneNumber')?.invalid && editProfileForm.get('userPhoneNumber')?.touched">
                    Numéro invalide (6 à 12 chiffres, avec ou sans indicatif)
                  </span>
                </div>

                <!-- CIN -->
                <div class="field-group">
                  <label class="field-label">
                    {{ 'PROFILE.FIELD_ID' | translate }}
                    <span class="field-optional">(optionnel)</span>
                  </label>
                  <div class="input-wrap">
                    <span class="input-prefix-icon"><i class="fas fa-id-card"></i></span>
                    <input type="text" class="modern-input readonly-input" formControlName="cinParent"
                           placeholder="12 345 678" />
                  </div>
                </div>

              </div>

              <!-- Submit -->
              <div class="form-actions">
                <button type="button" class="btn-cancel-form" (click)="loadProfile()">
                  <i class="fas fa-undo me-2"></i>Réinitialiser
                </button>
                <button type="button" class="btn-save-form" (click)="openConfirmSaveProfile()">
                  <i class="fas fa-save me-2"></i>{{ 'PROFILE.MODAL_SAVE' | translate }}
                </button>
              </div>

            </form>
          </div>

          <!-- ────── TAB: PAIEMENT ────── -->
          <div *ngIf="activeTab === 'paiement'" class="settings-card slide-in">

            <div class="card-section-header">
              <div class="card-header-left">
                <div class="card-header-icon gradient-green">
                  <i class="fas fa-receipt"></i>
                </div>
                <div>
                  <h2 class="card-section-title">Gestion des Frais de Scolarité</h2>
                  <p class="card-section-sub">Consultez vos paiements et réglez vos factures en ligne</p>
                </div>
              </div>
              <div class="card-header-actions">
                <button class="btn-ghost-warning" (click)="genererFactureTest()">
                  <i class="fas fa-magic me-2"></i>Générer facture test
                </button>
                <button class="btn-ghost-secondary" (click)="activeTab = 'profile'">
                  <i class="fas fa-arrow-left me-2"></i>Retour
                </button>
              </div>
            </div>

            <!-- Pending Payments -->
            <div class="payment-section">
              <div class="payment-section-title pending">
                <i class="fas fa-clock me-2"></i>À Payer — En attente
                <span class="payment-count-badge" *ngIf="pendingPaiements.length > 0">{{ pendingPaiements.length }}</span>
              </div>

              <div class="payment-table-wrap" *ngIf="pendingPaiements.length > 0; else noPending">
                <table class="payment-table">
                  <thead>
                    <tr>
                      <th>Enfant</th>
                      <th>Mois / Année</th>
                      <th>Date limite</th>
                      <th>Montant</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of pendingPaiements" class="payment-row">
                      <td>
                        <div class="child-cell">
                          <div class="child-avatar pending-avatar">{{ p.enfantName?.charAt(0) }}</div>
                          <span>{{ p.enfantName }}</span>
                        </div>
                      </td>
                      <td>{{ p.mois }}/{{ p.annee }}</td>
                      <td><span class="due-date">{{ p.dueDate | date:'dd/MM/yyyy' }}</span></td>
                      <td><span class="amount-badge">{{ p.montant }} TND</span></td>
                      <td>
                        <button class="btn-pay" (click)="openStripeModal(p.id)">
                          <i class="fas fa-credit-card me-2"></i>Payer en ligne
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noPending>
                <div class="empty-state">
                  <div class="empty-icon success-icon"><i class="fas fa-check-circle"></i></div>
                  <p class="empty-title">Tout est à jour !</p>
                  <p class="empty-sub">Aucun paiement en attente.</p>
                </div>
              </ng-template>
            </div>

            <!-- Paid History -->
            <div class="payment-section mt-4">
              <div class="payment-section-title paid">
                <i class="fas fa-history me-2"></i>Historique — Payés
              </div>

              <div class="payment-table-wrap" *ngIf="paidPaiements.length > 0; else noHistory">
                <table class="payment-table">
                  <thead>
                    <tr>
                      <th>Enfant</th>
                      <th>Mois / Année</th>
                      <th>Montant</th>
                      <th>Méthode</th>
                      <th>Date</th>
                      <th>Réf. Transaction</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of paidPaiements" class="payment-row">
                      <td>
                        <div class="child-cell">
                          <div class="child-avatar paid-avatar">{{ p.enfantName?.charAt(0) }}</div>
                          <span>{{ p.enfantName }}</span>
                        </div>
                      </td>
                      <td>{{ p.mois }}/{{ p.annee }}</td>
                      <td><span class="amount-paid">{{ p.montant }} TND</span></td>
                      <td>
                        <span class="method-chip">
                          <i class="fas fa-credit-card me-1" *ngIf="p.methodePaiement === 'CARTE_BANCAIRE'"></i>
                          <i class="fas fa-money-bill-wave me-1" *ngIf="p.methodePaiement === 'ESPECES'"></i>
                          {{ p.methodePaiement === 'CARTE_BANCAIRE' ? 'Carte' : 'Espèces' }}
                        </span>
                      </td>
                      <td>{{ p.datePaiement | date:'dd/MM/yyyy' }}</td>
                      <td><small class="txn-id">{{ p.transactionId || 'N/A' }}</small></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noHistory>
                <div class="empty-state">
                  <div class="empty-icon neutral-icon"><i class="fas fa-folder-open"></i></div>
                  <p class="empty-title">Aucun historique</p>
                  <p class="empty-sub">Les paiements effectués apparaîtront ici.</p>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- ────── TAB: NOTIFICATIONS ────── -->
          <div *ngIf="activeTab === 'notifications'" class="settings-card slide-in">

            <div class="card-section-header">
              <div class="card-header-left">
                <div class="card-header-icon gradient-orange">
                  <i class="fas fa-bell"></i>
                </div>
                <div>
                  <h2 class="card-section-title">Notifications</h2>
                  <p class="card-section-sub">
                    <span *ngIf="unreadCount > 0" class="unread-summary">{{ unreadCount }} non lue(s)</span>
                    <span *ngIf="unreadCount === 0" class="read-summary">Toutes lues ✓</span>
                  </p>
                </div>
              </div>
              <div class="card-header-actions">
                <button class="btn-ghost-secondary" (click)="loadNotificationsTab()">
                  <i class="fas fa-sync-alt me-1"></i>Actualiser
                </button>
                <button class="btn-ghost-primary" (click)="markAllRead()" *ngIf="unreadCount > 0">
                  <i class="fas fa-check-double me-1"></i>Tout marquer lu
                </button>
              </div>
            </div>

            <!-- Loading skeleton -->
            <div class="notif-loading" *ngIf="notifLoading">
              <div class="notif-skeleton" *ngFor="let i of [1,2,3,4]"></div>
            </div>

            <!-- Empty state -->
            <div class="empty-state m-4" *ngIf="!notifLoading && userNotifications.length === 0">
              <div class="empty-icon neutral-icon"><i class="fas fa-bell-slash"></i></div>
              <p class="empty-title">Aucune notification</p>
              <p class="empty-sub">Vous n'avez aucune notification pour le moment.</p>
            </div>

            <!-- Notification list -->
            <div class="notif-list" *ngIf="!notifLoading && userNotifications.length > 0">
              <div class="notif-item"
                   *ngFor="let n of userNotifications"
                   [class.notif-unread]="!n.read"
                   (click)="markNotifRead(n)">
                <div class="notif-stripe" [ngClass]="getNotifColorClass(n.type)"></div>
                <div class="notif-icon-bubble" [ngClass]="getNotifColorClass(n.type)">
                  <span>{{ getNotifIcon(n.type) }}</span>
                </div>
                <img [src]="n.photoUrl || 'assets/img/Admin.png'" class="notif-avatar" alt="avatar"
                     (error)="$any($event.target).src='assets/img/Admin.png'" />
                <div class="notif-body">
                  <p class="notif-text" [class.fw-bold]="!n.read">{{ n.content }}</p>
                  <span class="notif-time"><i class="fas fa-clock me-1"></i>{{ n.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>
                <div class="notif-unread-dot" *ngIf="!n.read"></div>
              </div>
            </div>

          </div>

        </main>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════
     MODAL — Changer le mot de passe (LARGE)
══════════════════════════════════════════ -->
<div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modern-modal-content password-modal">

      <!-- Left decorative panel -->
      <div class="pwd-modal-side">
        <div class="pwd-modal-side-inner">
          <div class="pwd-side-icon"><i class="fas fa-shield-alt"></i></div>
          <h3>Sécurité du compte</h3>
          <p>Choisissez un mot de passe fort avec au moins 8 caractères, une majuscule et un chiffre.</p>
          <ul class="pwd-tips">
            <li><i class="fas fa-check-circle"></i> Min. 8 caractères</li>
            <li><i class="fas fa-check-circle"></i> Au moins 1 majuscule</li>
            <li><i class="fas fa-check-circle"></i> Au moins 1 chiffre</li>
            <li><i class="fas fa-check-circle"></i> Caractère spécial recommandé</li>
          </ul>
        </div>
      </div>

      <!-- Right form panel -->
      <div class="pwd-modal-form">
        <div class="modern-modal-header" style="border-bottom:none; padding-bottom:0">
          <div class="modal-header-icon gradient-purple">
            <i class="fas fa-lock"></i>
          </div>
          <div>
            <h5 class="modern-modal-title">{{ 'PROFILE.PASSWORD_MODAL_TITLE' | translate }}</h5>
            <p class="modern-modal-sub">Choisissez un mot de passe fort</p>
          </div>
          <button type="button" class="modal-close-btn" data-bs-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modern-modal-body">
          <form [formGroup]="changePasswordForm" (ngSubmit)="confirmChangePassword()">

            <!-- Ancien mot de passe -->
            <div class="field-group mb-4">
              <label class="field-label">{{ 'PROFILE.PASSWORD_OLD' | translate }}</label>
              <div class="input-wrap">
                <span class="input-prefix-icon"><i class="fas fa-lock"></i></span>
                <input [type]="showOldPassword ? 'text' : 'password'" class="modern-input"
                       formControlName="oldPassword"
                       [placeholder]="'PROFILE.PASSWORD_OLD_PLACEHOLDER' | translate" />
                <button type="button" class="eye-btn" (click)="togglePasswordVisibility('old')">
                  <i class="fas" [ngClass]="showOldPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
            </div>

            <!-- Nouveau mot de passe + force -->
            <div class="field-group mb-2">
              <label class="field-label">{{ 'PROFILE.PASSWORD_NEW' | translate }}</label>
              <div class="input-wrap">
                <span class="input-prefix-icon"><i class="fas fa-key"></i></span>
                <input [type]="showNewPassword ? 'text' : 'password'" class="modern-input"
                       formControlName="newPassword"
                       [placeholder]="'PROFILE.PASSWORD_NEW_PLACEHOLDER' | translate"
                       (input)="onPasswordStrength()" />
                <button type="button" class="eye-btn" (click)="togglePasswordVisibility('new')">
                  <i class="fas" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              <span class="field-error" *ngIf="changePasswordForm.get('newPassword')?.errors?.['minlength']">
                {{ 'PROFILE.PASSWORD_MINLENGTH' | translate }}
              </span>
            </div>

            <!-- Password strength bar -->
            <div class="pwd-strength-wrap mb-4">
              <div class="pwd-strength-bar">
                <div class="pwd-strength-fill"
                     [style.width]="(passwordStrength / 5 * 100) + '%'"
                     [class.weak]="passwordStrength <= 1"
                     [class.medium]="passwordStrength === 2 || passwordStrength === 3"
                     [class.strong]="passwordStrength >= 4">
                </div>
              </div>
              <span class="pwd-strength-label"
                    [class.weak]="passwordStrength <= 1"
                    [class.medium]="passwordStrength === 2 || passwordStrength === 3"
                    [class.strong]="passwordStrength >= 4">
                <ng-container *ngIf="passwordStrength === 0">–</ng-container>
                <ng-container *ngIf="passwordStrength === 1">Très faible</ng-container>
                <ng-container *ngIf="passwordStrength === 2">Faible</ng-container>
                <ng-container *ngIf="passwordStrength === 3">Moyen</ng-container>
                <ng-container *ngIf="passwordStrength === 4">Fort</ng-container>
                <ng-container *ngIf="passwordStrength === 5">Très fort ✓</ng-container>
              </span>
            </div>

            <!-- Confirmer mot de passe -->
            <div class="field-group mb-4">
              <label class="field-label">{{ 'PROFILE.PASSWORD_CONFIRM' | translate }}</label>
              <div class="input-wrap" [class.input-error]="passwordMismatch">
                <span class="input-prefix-icon"><i class="fas fa-check-double"></i></span>
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="modern-input"
                       formControlName="confirmPassword"
                       [placeholder]="'PROFILE.PASSWORD_CONFIRM_PLACEHOLDER' | translate" />
                <button type="button" class="eye-btn" (click)="togglePasswordVisibility('confirm')">
                  <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              <span class="field-error" *ngIf="passwordMismatch">
                {{ 'PROFILE.PASSWORD_MISMATCH' | translate }}
              </span>
            </div>

            <div class="modal-form-actions">
              <button type="button" class="btn-modal-cancel" data-bs-dismiss="modal">
                {{ 'PROFILE.PASSWORD_CANCEL' | translate }}
              </button>
              <button type="submit" class="btn-modal-confirm"
                      [disabled]="changePasswordForm.invalid || passwordMismatch">
                <i class="fas fa-shield-alt me-2"></i>{{ 'PROFILE.PASSWORD_CHANGE' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════
     MODAL — Paiement en ligne (Stripe)
══════════════════════════════════════════ -->
<div class="custom-modal-overlay" *ngIf="isPaiementModalVisible" (click)="closePaiementModal()">
  <div class="custom-modal-box payment-modal-box" (click)="$event.stopPropagation()">

    <div class="payment-modal-header">
      <div class="modal-header-icon gradient-green">
        <i class="fas fa-lock"></i>
      </div>
      <div>
        <h5 class="modern-modal-title">Paiement Sécurisé</h5>
        <p class="modern-modal-sub">Transactions cryptées SSL</p>
      </div>
      <button class="modal-close-btn" (click)="closePaiementModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="payment-modal-body">
      <form [formGroup]="stripeForm" (ngSubmit)="soumettrePaiementOnline()">

        <div class="field-group mb-4">
          <label class="field-label">Nom sur la carte <span class="required-star">*</span></label>
          <div class="input-wrap">
            <span class="input-prefix-icon"><i class="fas fa-user"></i></span>
            <input type="text" class="modern-input" formControlName="cardholderName" placeholder="M. Parent" />
          </div>
        </div>

        <div class="field-group mb-4">
          <label class="field-label">Numéro de carte <span class="required-star">*</span></label>
          <div class="input-wrap">
            <span class="input-prefix-icon"><i class="fas fa-credit-card"></i></span>
            <input type="text" class="modern-input" formControlName="cardNumber"
                   placeholder="0000 0000 0000 0000" maxlength="16" />
          </div>
        </div>

        <div class="form-grid-2 mb-4">
          <div class="field-group">
            <label class="field-label">Expiration <span class="required-star">*</span></label>
            <div class="input-wrap">
              <span class="input-prefix-icon"><i class="fas fa-calendar"></i></span>
              <input type="text" class="modern-input" formControlName="expiry"
                     placeholder="MM/AA" maxlength="5" />
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">CVC <span class="required-star">*</span></label>
            <div class="input-wrap">
              <span class="input-prefix-icon"><i class="fas fa-lock"></i></span>
              <input type="text" class="modern-input" formControlName="cvc"
                     placeholder="123" maxlength="4" />
            </div>
          </div>
        </div>

        <div class="stripe-security-note">
          <i class="fas fa-shield-alt"></i>
          Toutes les transactions sont sécurisées et cryptées par Stripe.
        </div>

        <div class="modal-form-actions mt-3">
          <button type="button" class="btn-modal-cancel" (click)="closePaiementModal()">Annuler</button>
          <button type="submit" class="btn-modal-success" [disabled]="stripeForm.invalid">
            <i class="fas fa-check-circle me-2"></i>Confirmer le paiement
          </button>
        </div>
      </form>
    </div>
  </div>
</div>